var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-ring-width l-flex l-flex--column"},[_c('div',{class:_vm.imageClass}),_vm._v(" "),_c('p',{staticClass:"t-paragraph"},[_vm._v("\n    "+_vm._s(_vm.width)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }